



























































import { Vue, Component, Watch } from 'vue-property-decorator';
import { Action, State, namespace } from 'vuex-class';
import Container from '@/components/Container.vue';
import Receipt from './components/Receipt.vue';
import { RootState } from '@/store/store';
import {
  BPointV3TxnResp,
  BPointV5TxnResp,
  OldOrderDTO
} from '@/store/modules/order/order.types';
import { NotificationProgrammatic as Notification } from 'buefy';
import { moneyParser } from '../../utils/parser.util';
import { Product } from '@/store/modules/application/types/application.types';
import { JAAS_APP } from '../../jbi-shared/types/jaas-app.types';

@Component({
  components: {
    Receipt,
    Container
  }
})
export default class OrderPage extends Vue {
  @Action('order/orderReset') public orderReset!: () => Promise<void>;

  @Action('order/getOrder') public getOrder!: (id: number) => Promise<void>;

  @Action('order/updateOrder')
  public updateOrder!: ({
    id,
    resultKey
  }: {
    id: number;
    resultKey: string | string[];
  }) => Promise<void>;

  @Action('application/getProduct')
  public getProduct!: ({ productId }: { productId: number }) => Promise<void>;

  @State(({ order }: RootState) => order.apiState.getOrder.success)
  public getOrderSuccessState!: Boolean;

  @State(({ order }: RootState) => order.order)
  public order!: OldOrderDTO;

  @State(({ application }: RootState) => application.product)
  public product!: Product;

  get applicationUrl() {
    if (this.product) {
      const redirectURL =
        this.product.applicationId === JAAS_APP.paces
          ? process.env.VUE_APP_PACES_FRONTEND_URL
          : this.product.applicationId === JAAS_APP.sumari
          ? process.env.VUE_APP_SUMARI_URL
          : 'https://google.com';
      return redirectURL;
    }
  }

  //TODO: JAAS-2828 Get only required field in json from backend itself while working for new UI of View Receipt
  get bPointPayload() {
    let cardHolderName = 'N/A';
    let maskedCardNumber = 'N/A';
    let receiptNumber = '-';
    let merchantNumber = '-';

    if (this.order.paymentTxnResponsePayload) {
      cardHolderName =
        (this.order.paymentTxnResponsePayload as BPointV3TxnResp).CardDetails
          ?.CardHolderName || 'N/A';

      maskedCardNumber =
        (this.order.paymentTxnResponsePayload as BPointV3TxnResp).CardDetails
          ?.MaskedCardNumber ||
        (this.order.paymentTxnResponsePayload as BPointV5TxnResp).paymentMethod
          ?.card.number ||
        'N/A';

      receiptNumber =
        (this.order.paymentTxnResponsePayload as BPointV3TxnResp)
          .ReceiptNumber ||
        (this.order.paymentTxnResponsePayload as BPointV5TxnResp)
          .receiptNumber ||
        '-';

      merchantNumber =
        (this.order.paymentTxnResponsePayload as BPointV3TxnResp)
          .MerchantNumber ||
        (this.order.paymentTxnResponsePayload as BPointV5TxnResp)
          .merchantNumber ||
        '-';
    }

    const streetAddress = this.order.streetAddress
      ? this.order.streetAddress.replace(/,\s*$/, '') + ', '
      : '';
    const city = this.order.city ? this.order.city + ', ' : '';
    const country = this.order.country ? this.order.country : '';

    const billingAddress = country
      ? `${streetAddress} ${city} ${country}`
      : 'N/A';

    const amount = this.order.paymentAmount / 100;
    const gstAmount = +(this.order.gstAmount / 100).toFixed(2);
    const gstPercentage =
      gstAmount > 0
        ? `(${Math.round((amount / (amount - gstAmount) - 1) * 100)}%)`
        : '';

    // TODO: amount and gst should return from server
    // prettier-ignore

    return {
      productName: this.order.productName,
      price: moneyParser({
        value: this.order.paymentAmount - this.order.gstAmount
      }),
      gst: gstAmount > 0 ? moneyParser({ value: this.order.gstAmount }) : 'N/A',
      amount: moneyParser({ value: this.order.paymentAmount }),
      cardHolderName: cardHolderName,
      cardNumber: maskedCardNumber,
      receiptNumber: receiptNumber,
      merchantNumber: merchantNumber,
      billingAddress,
      gstPercentage
    };
  }

  get orderId() {
    return +this.$route.params.id;
  }

  public async paymentCallback() {
    const {
      ResultKey: resultKey,
      ResponseText: responseText,
      ResponseCode: responseCode
    } = this.$route.query;

    if (resultKey) {
      // TODO: trigger callback
      await this.updateOrder({
        id: this.orderId,
        resultKey: resultKey as string
      });
    }
  }

  get urlQuery() {
    return this.$route.query;
  }

  public async mounted() {
    await this.orderReset();

    await this.paymentCallback();

    await this.getOrder(this.orderId);

    await this.getProduct({ productId: this.order.productId });

    if (!this.order) {
      this.$router.replace({ name: 'page-not-found' });
      return;
    }

    if (this.order.paymentStatus === 'FAILED') {
      this.$router.replace({ name: 'Orders' }).then(() => {
        Notification.open({
          queue: true,
          type: 'is-danger',
          position: 'is-top',
          duration: 10000,
          message: `<b>Payment Failed</b>. Please try again later.`
        });
      });
    }
  }
}
